import axios from "axios";

export const CustomUrl ={
  USERS:"USERS",
  STORES:"STORES",
  PRODUCT_TYPES:"PRODUCT_TYPES",
  FLAVORS:"FLAVORS",
  FLAVOR_DRIVEN_TREATS:"FLAVOR_DRIVEN_TREATS",
  PRODUCTION_SHEET:"PRODUCTION_SHEET",
  MERCHANDISE_SITE:"MERCHANDISE_SITE",
  PRESELL_BOARD:"PRESELL_BOARD",
  ONLINE_VENDOR_ORDERING:"ONLINE_VENDOR_ORDERING",
  DMB_WEB_APP:"DMB_WEB_APP",
  CATERING_PORTAL: "CATERING_PORTAL",
  RFC_LIBRARY:"RFC_LIBRARY",
  PL_TOOL: "PL_TOOL"
}
export class CommonServiceUtils {
  postData = (url, req = null, config = {}) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, req, config)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          if (url?.includes('signin'))
            reject(err);
          else
            reject(err?.message);
        });
    });

  getData = (url, req = null) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, req)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });

  patchData = (url, req = null) =>
    new Promise((resolve, reject) => {
      axios
        .patch(url, req)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });

    putData = (url, req = null) =>
      new Promise((resolve, reject) => {
        axios
          .put(url, req)
          .then((res) => {
            resolve(res?.data);
          })
          .catch((err) => {
            reject(err);
          });
      });

  deleteData = (url, data) =>
    new Promise((resolve, reject) => {
      axios
        .delete(url, {data})
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });

  apiUrlCreator = (endPoint,customUrl="") => {
    if(process.env.REACT_APP_AUTO_PIPELINE === "true"){
      switch (customUrl) {
        case CustomUrl.FLAVORS:
          return `${process.env.REACT_APP_API_FLAVORS}/${endPoint}`;
        case CustomUrl.FLAVOR_DRIVEN_TREATS:
          return `${process.env.REACT_APP_API_FLAVOR_DRIVEN_TREATS || process.env.REACT_APP_API_FLAVORS}/${endPoint}`;
        case CustomUrl.USERS:
          return `${process.env.REACT_APP_API_USERS}/${endPoint}`;
        case CustomUrl.STORES:
          return `${process.env.REACT_APP_API_STORES}/${endPoint}`;
        case CustomUrl.PRODUCT_TYPES:
          return `${process.env.REACT_APP_API_PRODUCT_TYPES}/${endPoint}`;
        case CustomUrl.PRODUCTION_SHEET:
          return `${process.env.REACT_APP_API_PRODUCTION_SHEET}/${endPoint}`;
        case CustomUrl.PRESELL_BOARD:
          return `${process.env.REACT_APP_API_PRESELL_BOARD}/${endPoint}`;
        case CustomUrl.MERCHANDISE_SITE:
          return `${process.env.REACT_APP_API_MERCHANDISE_SITE}/${endPoint}`;
        case CustomUrl.ONLINE_VENDOR_ORDERING:
          return `${process.env.REACT_APP_API_ONLINE_VENDOR_ORDERING}/${endPoint}`;
        case CustomUrl.DMB_WEB_APP:
          return `${process.env.REACT_APP_API_DMB_WEB_APP}/${endPoint}`;
        case CustomUrl.CATERING_PORTAL:
          return `${process.env.REACT_APP_API_CATERING_PORTAL}/${endPoint}`;
        case CustomUrl.PL_TOOL:
          return `${process.env.REACT_APP_API_PL_TOOL}/${endPoint}`;
        case CustomUrl.RFC_LIBRARY:
          if (!process.env.REACT_APP_API_RFC_LIBRARY) {
            throw new Error("REACT_APP_API_RFC_LIBRARY is not configured");
          }
          return `${process.env.REACT_APP_API_RFC_LIBRARY}/${endPoint}`;
        default:
          return `${process.env.REACT_APP_API_URL}/${endPoint}`;
      }
    }
    return `${process.env.REACT_APP_API_URL}/${endPoint}`;
  
  };
}
